<template>
  <div id="program-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px;">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <label style="display: block">{{this.$t('subEvent')}}</label>
                    <el-select :disabled="isSubEventDisabled" v-model="form.subEventID" clearable>
                      <el-option
                        v-for="item in $store.state.subevents.items"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <span class="error">
                      {{
                      $errorMessage("subEventID", validationErrors)
                      }}
                    </span>
                  </div>
                </div>

                <div class="row" style="margin-top: 20px;">
                  <div class="col-md-6">
                    <div>
                      <h4 style="font-size: 16px">{{this.$t('event.menu.participants.title')}}</h4>
                      <el-input
                        style="margin-bottom: 10px"
                        v-model="$store.state.participants.filter.searchTerm"
                        :placeholder="$t('searchPart')"
                      ></el-input>
                      <el-select
                        style="margin-bottom: 10px;"
                        multiple
                        v-model="$store.state.participants.filter.tagIDs"
                        :placeholder="$t('event.textbox.selectTag')"
                      >
                        <el-option
                          v-for="item in $store.state.tags.items"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        >
                          <div
                            style="display: flex; flex-direction: row; align-items: center; justify-content: space-between"
                          >
                            <span style="float: left">{{ item.title }}</span>
                            <span
                              style="float: right; color: #8492a6; font-size: 13px; width: 15px; height: 15px; display: inline-block"
                              :style="'background-color: ' + item.color"
                            ></span>
                          </div>
                        </el-option>
                      </el-select>
                      <div v-loading="$store.state.participants.loading">
                        <div
                          v-for="item in $store.state.participants.items"
                          :key="item.id"
                          style="display: flex; flex-direction: row; align-items: center; padding: 5px 5px; box-shadow: -1px 2px 6px rgba(0,0,0,.1); margin-bottom: 5px"
                        >
                          <div
                            style="margin-left: 10px; display: flex; flex-direction: column; flex: 1"
                          >
                            <ParticipantMini :data="item" />
                          </div>
                          <el-button
                            v-if="!form.participantIDs.some((k) => k.id == item.id)"
                            @click="form.participantIDs.push(item)"
                            type="success"
                            icon="el-icon-arrow-right"
                            circle
                          ></el-button>
                          <el-button
                            v-if="form.participantIDs.some((k) => k.id == item.id)"
                            @click="
                              form.participantIDs.splice(
                                form.participantIDs.findIndex((k) => k.id == item.id),
                                1
                              )
                            "
                            type="danger"
                            icon="el-icon-close"
                            circle
                          ></el-button>
                        </div>
                      </div>
                      <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="$store.state.participants.filter.page"
                        :page-sizes="[20, 30, 40, 50]"
                        :page-size="$store.state.participants.filter.take"
                        layout="prev, pager, next"
                        :total="$store.state.participants.filter.total"
                      ></el-pagination>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <h4 style="font-size: 16px">{{this.$t('selectedParticipants')}}</h4>
                    <draggable v-model="form.participantIDs" v-bind="dragOptions">
                      <transition-group type="transition" name="flip-list">
                        <div
                          class="list-group-item"
                          v-for="item in form.participantIDs"
                          :key="item.id"
                          style="display: flex; flex-direction: row; align-items: center; padding: 5px 5px; box-shadow: -1px 2px 6px rgba(0,0,0,.1); margin-bottom: 5px"
                        >
                          <div
                            style="margin-left: 10px; display: flex; flex-direction: column; flex: 1"
                          >
                            <ParticipantMini :data="item" />
                          </div>
                          <el-button
                            v-if="!form.participantIDs.some((k) => k.id == item.id)"
                            @click="form.participantIDs.push(item)"
                            type="success"
                            icon="el-icon-arrow-right"
                            circle
                          ></el-button>
                          <el-button
                            v-if="form.participantIDs.some((k) => k.id == item.id)"
                            @click="
                              form.participantIDs.splice(
                                form.participantIDs.findIndex((k) => k.id == item.id),
                                1
                              )
                            "
                            type="danger"
                            icon="el-icon-close"
                            circle
                          ></el-button>
                        </div>
                      </transition-group>
                    </draggable>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; padding: 0"
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t('event.table.delete') }}</el-button>
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="display: flex; flex: 1; align-items: center; justify-content: flex-end"
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                      >{{$t('event.buttons.close')}}</el-button>
                      <el-button type="success" @click="save">{{$t("event.buttons.save")}}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="display: flex; width: 100%; align-items: center; justify-content: center; cursor: pointer; padding: 10px 0px"
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import draggable from "vuedraggable";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import DayAddUpdate from "./DayAddUpdate";
import SaloonAddUpdate from "./SaloonAddUpdate";
import SubEventAddUpdate from "./SubEventAddUpdate";
import VenueAddUpdate from "./VenueAddUpdate";
import $ from "jquery";

import { quillEditor } from "vue-quill-editor";
export default {
  components: {
    ItemInfo,
    draggable,
    quillEditor,
    DayAddUpdate,
    SaloonAddUpdate,
    SubEventAddUpdate,
    VenueAddUpdate,
  },
  name: "RegistrationAddUpdate",
  props: ["data"],
  data() {
    return {
      form: {
        participantIDs: [],
        subEventID: null,
      },
      addNewSubEvent: false,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      addGroupModal: false,
      addNewDay: false,
      addNewSaloon: false,
      addVenue: false,
    };
  },
  mounted() {
    this.$store.dispatch("getSubEvents");
    this.$store.dispatch("getParticipants");
  },
  methods: {
    async itemAdded(item) {
      await this.$store.dispatch("getSubEventRegistrations");
      this.form.dayID = item;
    },
    handleSizeChange(take) {
      this.$store.commit("setSSubEventRegistrationTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSSubEventRegistrationPage", page);
    },
    deleteItem() {
      var index = this.$store.state.program.items.findIndex(
        (k) => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      this.validationErrors = [];

      var participants = [];

      this.form.participantIDs.map((x) => {
        participants.push(x.id);
      });

      axios
        .post("Participant/AddSubEventRegistrations", {
          ...this.form,
          participantIDs: participants,
        })
        .then((res) => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            if (this.form.id == null) {
              this.$emit("itemAdded");
              this.form = {
                participantIDs: [],
                subEventID: null,
              };
            } else {
              this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
              if (this.showInfo) {
                this.showInfo = false;
                setTimeout(() => {
                  this.showInfo = true;
                }, 350);
              }
            }
          }
        });
    },
  },
  watch: {
    data: function (newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = this.data;
        this.validationErrors = [];
      } else {
        this.form = {
          participantIDs: [],
          subEventID: null,
        };
      }
    },
    "$store.state.participants.filter.searchTerm": function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");
      }, 500);
    },
    "$store.state.participants.filter.tagIDs": function () {
      this.$store.dispatch("getParticipants");
    },
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }

    this.$store.commit("setSpeakerTake", 5);
  },
  computed: {
    getVenues() {
      if (this.form.subEventID != null && this.form.subEventID != "") {
        return this.$store.state.venues.items.filter((k) => k.type == 3);
      }
      return this.$store.state.venues.items;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    isSubEventDisabled() {
      if (this.form.venueID == null || this.form.venueID == "") return false;
      var venue = this.$store.state.venues.items.find(
        (k) => k.id == this.form.venueID
      );
      return venue.type != 3;
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SubEventRegistrationAdd.vue